import React from "react";
import { isChunkLoadError, reloadOnceForChunkError } from "./chunkReload";

const lazyWithReload = <T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> =>
  React.lazy(() =>
    factory().catch((error: unknown) => {
      if (isChunkLoadError(error) && reloadOnceForChunkError()) {
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    })
  );

export default lazyWithReload;
